export function loadBMap(ak) {
    return new Promise((resolve, reject) => {
        //聚合API依赖基础库,因此先加载基础库再加载聚合API
        asyncLoadBaiduJs(ak)
            .then(() => {
                // 调用加载第三方组件js公共方法加载其他资源库
                // 加载聚合API
                // MarkerClusterer_min.js依赖TextIconOverlay.js。因此先加载TextIconOverlay.js
                asyncLoadJs('http://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay.js')
                    .then(() => {
                        asyncLoadJs('http://api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js')
                            .then(() => {
                                asyncLoadJs('http://api.map.baidu.com/library/InfoBox/1.2/src/InfoBox_min.js')
                                    .then(() => {
                                        resolve()
                                        return true
                                    })
                                    .catch(err => { reject(err) })
                            })
                            .catch(err => { reject(err) })
                    })
                    .catch(err => { reject(err) })
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 加载百度地图基础组件js
export function asyncLoadBaiduJs(ak) {
    return new Promise((resolve, reject) => {
        if (typeof BMap !== 'undefined') {
            resolve(BMap)
            return true
        }
        window.onBMapCallback = function () {
            resolve(BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'http://api.map.baidu.com/api?v=3.0&ak=' + ak + '&callback='
        script.onerror = reject
        document.head.appendChild(script)
    })
}
// 加载第三方组件js公共方法
export function asyncLoadJs(url) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = url
        document.head.appendChild(script)
        script.onload = () => {
            resolve()
        }
        script.onerror = reject
    })
}

export function Map(ak) {
    return new Promise(function (resolve, reject) {
        window.init = function () {
            resolve(BMapGL)
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "//api.map.baidu.com/api?v=3.0&type=webgl&ak=" + ak + "&callback=init";
        script.onerror = reject;
        document.head.appendChild(script);
    })
}



export default function loadBMap1(ak) {
    return new Promise((resolve, reject) => {
        //聚合API依赖基础库,因此先加载基础库再加载聚合API
        Map(ak)
            .then(() => {
                // 调用加载第三方组件js公共方法加载其他资源库
                // 加载聚合API
                // MarkerClusterer_min.js依赖TextIconOverlay.js。因此先加载TextIconOverlay.js
                asyncLoadJs(process.env.NODE_ENV === 'development'?'mapv/common.js':'static/mapv/common.js')
                    .then(() => {
                        asyncLoadJs(process.env.NODE_ENV === 'development'?'mapv/mapv.min.js':'static/mapv/mapv.min.js')
                            .then(() => {
                                asyncLoadJs(process.env.NODE_ENV === 'development'?'mapv/mapvgl.min.js':'static/mapv/mapvgl.min.js')
                                    .then(() => {
                                        // asyncLoadJs(process.env.NODE_ENV === 'development'?'mapv/DrawingManager.min.js':'static/mapv/DrawingManager.min.js')
                                        asyncLoadJs(process.env.NODE_ENV === 'development'?'mapv/bmap-draw.min.js':'static/mapv/bmap-draw.min.js')
                                            .then(() => {
                                                
                                                // resolve({BMapGL,BMapGLLib})
                                                resolve({BMapGL,BMapGLDraw})
                                                return true
                                            })
                                            .catch(err => { reject(err) })
                                    })
                                    .catch(err => { reject(err) })
                            })
                            .catch(err => { reject(err) })
                    })
                    .catch(err => { reject(err) })
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function loadBMap2(ak) {
    return new Promise((resolve, reject) => {
        //聚合API依赖基础库,因此先加载基础库再加载聚合API
        asyncLoadBaiduJs(ak)
            .then(() => {
                // 调用加载第三方组件js公共方法加载其他资源库
                // 加载聚合API
                // MarkerClusterer_min.js依赖TextIconOverlay.js。因此先加载TextIconOverlay.js
                asyncLoadJs('http://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay.js')
                    .then(() => {
                        asyncLoadJs('http://api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js')
                            .then(() => {
                                asyncLoadJs('http://api.map.baidu.com/library/InfoBox/1.2/src/InfoBox_min.js')
                                    .then(() => {
                                        resolve()
                                        return true
                                    })
                                    .catch(err => { reject(err) })
                            })
                            .catch(err => { reject(err) })
                    })
                    .catch(err => { reject(err) })
            })
            .catch(err => {
                reject(err)
            })
    })
}


export function MapGoole(ak) {
    return new Promise(function (resolve, reject) {
        window.init = function () {
            resolve(google)
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "google1";
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + ak + "&callback=init";
        script.onerror = reject;
        document.head.appendChild(script);
    })
}

export function loadBMapGoogle(ak) {
    return new Promise((resolve, reject) => {
        //聚合API依赖基础库,因此先加载基础库再加载聚合API
        MapGoole(ak)
            .then(() => {
                // 调用加载第三方组件js公共方法加载其他资源库
                // 加载聚合API
                // MarkerClusterer_min.js依赖TextIconOverlay.js。因此先加载TextIconOverlay.js
                asyncLoadJs('https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js')
                    .then(() => {
                        resolve()
                        return true
                    })
                    .catch(err => { reject(err) })
            })
            .catch(err => {
                reject(err)
            })
    })
}



